


























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import CKEditor from "ckeditor4-vue";
@Component({
  components: {
    ckeditor: CKEditor.component,
  },
})
export default class WysiwygEditor extends Vue {
  @Prop() readonly value!: string;
  @Prop({ required: false, default: null })
  readonly caminhoUploadImagem!: string;
  @Prop({ default: () => new Array<(val: unknown) => true | string>() })
  readonly rules!: Array<(val: unknown) => true | string>;

  editorData = "";
  editorConfig: any = {
    versionCheck: false,
    forcePasteAsPlainText: false,
    basicEntities: true,
    entities: true,
    allowedContent: true
  };
  errors: string[] | null = null;

  mounted() {
    this.editorData = this.value;
    if (this.caminhoUploadImagem) {
      this.editorConfig = {
        forcePasteAsPlainText: false,
        basicEntities: true,
        entities: true,
        allowedContent: true,
        filebrowserUploadUrl: this.caminhoUploadImagem,
        filebrowserImageUploadUrl: this.caminhoUploadImagem,
      };
    }
  }

  /**
   * Valida o campo com as rules informada no prop
   */
  validate() {
    //Caso tenha upload de imagem atualizar o conteudo do editor (Quando o upload acontece via drop de arquivo, o componente CKEditor não invoca o evento input e assim não atualiza a variável...
    //... editorData sozinho ao validar o editor esse comando vai forçar a atualização e o watch do componente vai invocar o input do nosso tradutor de componente WysiwygEditor
    if (this.caminhoUploadImagem)
      this.editorData = (this.$refs.editor as any).instance.getData() as string;

    //Obter erros
    if (this.rules.length > 0)
      this.errors = (this.rules ?? ([] as string[]))
        .map((args) => args(this.editorData))
        .filter((args) => typeof args == "string") as string[];

    return (this.errors?.length ?? 0) === 0;
  }

  @Watch("value")
  onValueChange(val: string) {
    this.editorData = val;
  }

  @Watch("editorData")
  onChange(val: string) {
    this.$emit("input", val);
  }
}
